import React from 'react';
import PropTypes from 'prop-types';

function Star({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M14.489 8.917l.079.168.183.028 5.004.762s0 0 0 0c.146.023.268.172.241.354v.004a.323.323 0 01-.088.182s0 0 0 0l-3.62 3.697-.124.126.029.173.855 5.221v0c.03.185-.09.337-.233.363h0a.254.254 0 01-.169-.027l-.002-.001-4.476-2.465L12 17.41l-.168.092-4.476 2.465h-.001a.258.258 0 01-.285-.022.308.308 0 01-.1-.134.34.34 0 01-.018-.178h0l.855-5.222.029-.173-.123-.126-3.622-3.697h0A.33.33 0 014 10.189a.33.33 0 01.086-.229.272.272 0 01.157-.085h.001l5.005-.762.184-.028.079-.168 2.236-4.748s0 0 0 0c.077-.159.245-.206.372-.14h0c.055.028.102.075.131.138h0l2.238 4.75z" />
    </svg>
  );
}

Star.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Star;
